import { useFormContext } from "react-hook-form";

import FormInput from "@/components/form-fields/form-input";
import { GooglePlaces } from "@/components/reusables/custom-form-fields/GooglePlaces";
import MapPicker from "@/components/reusables/custom-form-fields/MapPicker";
import { FIVE } from "@/constants/constants";
import { TAddProjectSchema } from "@/schemas/project.schema";

const ProjectAddress = (): React.ReactElement => {
  const form = useFormContext<TAddProjectSchema>();
  const { watch, setValue, formState } = form;

  return (
    <>
      <h2 className='col-span-3 text-lg font-medium'>Project Address</h2>
      <div>
        <GooglePlaces
          defaultValue={watch("address")?.label}
          label='Search Project Address'
          setSelectedLocation={(data) =>
            setValue(
              "address",
              {
                label: data.label,
                radius: watch("address")?.radius || 0,
                latitude: data.lat.toString(),
                longitude: data.lng.toString(),
              },
              { shouldDirty: true },
            )
          }
          showErrorMessage={!!formState.errors?.address}
          required
        />
      </div>

      <FormInput
        name='address.areaLocation'
        form={form}
        label='Area Location'
        input={{
          placeholder: "Please Enter Area Location",
        }}
      />

      <FormInput
        name='address.radius'
        form={form}
        charLimit={FIVE}
        label='Radius (in meters)'
        required
        input={{
          type: "number",
          placeholder: "Please Enter Radius",
        }}
      />
      <FormInput
        form={form}
        name='address'
        className='col-span-3'
        render={(field) => (
          <MapPicker
            height='300px'
            width='100%'
            value={{
              lat: parseFloat(field.value?.latitude || "0"),
              lng: parseFloat(field.value?.longitude || "0"),
            }}
            onChange={(data, displayName) => {
              field.onChange({
                ...watch("address"),
                latitude: data.lat.toString(),
                longitude: data.lng.toString(),
                label: displayName,
              });
            }}
            copyLatClassName='w-[37%]'
          />
        )}
      />
    </>
  );
};

export default ProjectAddress;
